var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_361_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2662 9.78491C6.19879 6.95902 8.85445 4.92948 12 4.92948C13.6909 4.92948 15.2182 5.52948 16.4182 6.51129L19.9091 3.02039C17.7818 1.16584 15.0545 0.0203857 12 0.0203857C7.27007 0.0203857 3.19775 2.71868 1.23999 6.67041L5.2662 9.78491Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0407 18.033C14.9509 18.7367 13.5661 19.1113 12 19.1113C8.86648 19.1113 6.21911 17.0973 5.27698 14.2883L1.23746 17.3554C3.19279 21.314 7.265 24.0204 12 24.0204C14.9328 24.0204 17.7353 22.9778 19.8342 21.02L16.0407 18.033Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8342 21.02C22.0292 18.9725 23.4545 15.9241 23.4545 12.0204C23.4545 11.3113 23.3455 10.5477 23.1818 9.83857H12V14.4749H18.4364C18.1188 16.034 17.2663 17.2416 16.0407 18.033L19.8342 21.02Z",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27698 14.2883C5.03833 13.5767 4.90909 12.8141 4.90909 12.0204C4.90909 11.2387 5.03444 10.4872 5.2662 9.78491L1.23999 6.67041C0.436587 8.28082 0 10.0958 0 12.0204C0 13.9399 0.444781 15.7506 1.23746 17.3554L5.27698 14.2883Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_361_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0203857)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.be55897164f110394f2f4fbbf8d58206.svg";
export { ForwardRef as ReactComponent };